import { z } from "zod";

export const conditionsValidatedDtoSchema = z.object({
  name: z.string(),
  validated: z.boolean(),
});

export type TConditionsValidatedDto = z.infer<typeof conditionsValidatedDtoSchema>;
